import { render, staticRenderFns } from "./addapplicationState.vue?vue&type=template&id=36afb8f0&scoped=true"
import script from "./addapplicationState.vue?vue&type=script&lang=js"
export * from "./addapplicationState.vue?vue&type=script&lang=js"
import style0 from "./addapplicationState.vue?vue&type=style&index=0&id=36afb8f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36afb8f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/www/prod-cn-snote-manage/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36afb8f0')) {
      api.createRecord('36afb8f0', component.options)
    } else {
      api.reload('36afb8f0', component.options)
    }
    module.hot.accept("./addapplicationState.vue?vue&type=template&id=36afb8f0&scoped=true", function () {
      api.rerender('36afb8f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/firmware/addapplicationState.vue"
export default component.exports